"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.UpdateDesignerProjectDocument = exports.TrackEventDocument = exports.RestoreDesignerProjectDocument = exports.RenameDesignerProjectDocument = exports.ProfileDocument = exports.ListVoiceboxConversationsDocument = exports.ListConnectionsDocument = exports.GetVoiceboxConversationDocument = exports.GetDesignerProjectsDocument = exports.GetDesignerProjectDocument = exports.GetConnectionByIndexDocument = exports.CreateDesignerProjectDocument = exports.ArchiveDesignerProjectDocument = exports.AddShareDocument = exports.DesignerProjectRoleChoices = void 0;
var DesignerProjectRoleChoices;
(function (DesignerProjectRoleChoices) {
    DesignerProjectRoleChoices["Editor"] = "EDITOR";
    DesignerProjectRoleChoices["Viewer"] = "VIEWER";
})(DesignerProjectRoleChoices = exports.DesignerProjectRoleChoices || (exports.DesignerProjectRoleChoices = {}));
exports.AddShareDocument = `
    mutation addShare($input: ShareInput!) {
  addShare(input: $input) {
    short_url
  }
}
    `;
exports.ArchiveDesignerProjectDocument = `
    mutation archiveDesignerProject($project_id: ID!) {
  archiveDesignerProject(project_id: $project_id)
}
    `;
exports.CreateDesignerProjectDocument = `
    mutation createDesignerProject($name: String!, $content: Base64Bytes!) {
  createDesignerProject(name: $name, content: $content)
}
    `;
exports.GetConnectionByIndexDocument = `
    query getConnectionByIndex($index: Int!) {
  connection: getConnectionByIndex(index: $index) {
    token
    useBrowserAuth
    username
    endpoint
    dashboard
    id
    name
    index
  }
}
    `;
exports.GetDesignerProjectDocument = `
    query getDesignerProject($project_id: ID!) {
  getDesignerProject(project_id: $project_id) {
    id
    name
    content
    created_at
    updated_at
    owner {
      id
      username
    }
    roles {
      role
      user {
        id
        username
      }
    }
  }
}
    `;
exports.GetDesignerProjectsDocument = `
    query getDesignerProjects {
  getDesignerProjects {
    id
    name
    created_at
    updated_at
    owner {
      id
      username
    }
    roles {
      role
      user {
        id
        username
      }
    }
  }
}
    `;
exports.GetVoiceboxConversationDocument = `
    query getVoiceboxConversation($conversation_id: String!) {
  getVoiceboxConversation(conversation_id: $conversation_id) {
    id
    message_history {
      id
      content
      sender
      score
      user_message_context {
        app
        connection_id
        database
        named_graphs
        model
        reasoning
      }
      system_message_context {
        followup_examples
        actions {
          type
          label
          value
        }
        message_type
        pending
        success
      }
    }
  }
}
    `;
exports.ListConnectionsDocument = `
    query listConnections {
  listConnections {
    dashboard
    endpoint
    id
    index
    name
    token
    useBrowserAuth
    username
  }
}
    `;
exports.ListVoiceboxConversationsDocument = `
    query listVoiceboxConversations($paging: PagingInput) {
  listVoiceboxConversations(paging: $paging) {
    id
    last_user_message {
      id
      user_message_context {
        connection_id
        database
        named_graphs
        model
        reasoning
      }
    }
  }
  voiceboxConversationCount {
    count
  }
}
    `;
exports.ProfileDocument = `
    query profile {
  profile {
    first_name
    last_name
    username
    company
    date_joined
    email
    id
    is_databricks_user
    title
    use_case
    is_authenticated
    is_ephemeral
    userflow_signature
    is_staff
    is_static_voicebox
    is_voicebox_enabled
    is_designer_storage_enabled
    is_voicebox_powered_suggestions_enabled
    is_voicebox_three_enabled
  }
}
    `;
exports.RenameDesignerProjectDocument = `
    mutation renameDesignerProject($project_id: ID!, $name: String!) {
  renameDesignerProject(project_id: $project_id, name: $name)
}
    `;
exports.RestoreDesignerProjectDocument = `
    mutation restoreDesignerProject($project_id: ID!) {
  restoreDesignerProject(project_id: $project_id)
}
    `;
exports.TrackEventDocument = `
    mutation trackEvent($input: TrackEventInput!) {
  trackEvent(input: $input) {
    success
    error
  }
}
    `;
exports.UpdateDesignerProjectDocument = `
    mutation updateDesignerProject($project_id: ID!, $content: Base64Bytes!, $name: String) {
  updateDesignerProject(project_id: $project_id, content: $content, name: $name)
}
    `;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        addShare(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.AddShareDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'addShare', 'mutation');
        },
        archiveDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ArchiveDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'archiveDesignerProject', 'mutation');
        },
        createDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.CreateDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'createDesignerProject', 'mutation');
        },
        getConnectionByIndex(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetConnectionByIndexDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getConnectionByIndex', 'query');
        },
        getDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getDesignerProject', 'query');
        },
        getDesignerProjects(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetDesignerProjectsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getDesignerProjects', 'query');
        },
        getVoiceboxConversation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetVoiceboxConversationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getVoiceboxConversation', 'query');
        },
        listConnections(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ListConnectionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'listConnections', 'query');
        },
        listVoiceboxConversations(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ListVoiceboxConversationsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'listVoiceboxConversations', 'query');
        },
        profile(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ProfileDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'profile', 'query');
        },
        renameDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.RenameDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'renameDesignerProject', 'mutation');
        },
        restoreDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.RestoreDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'restoreDesignerProject', 'mutation');
        },
        trackEvent(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.TrackEventDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'trackEvent', 'mutation');
        },
        updateDesignerProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.UpdateDesignerProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'updateDesignerProject', 'mutation');
        },
    };
}
exports.getSdk = getSdk;
